<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true" :isLoading="isLoading">
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
             <bita-input
              type="text"
              name="vehicle_type_code"
              label="کد"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.vehicle_type_code"
            />

            
            <bita-select
              v-if="categories.length > 0"
              name="categories"
              label="دسته بندی"
              rules="required"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="categories"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.parent_id"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!propsData.id"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-if="propsData.id"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    categories: {
      type: Array,
      default: [],
    },
    propsData: {
      type: Object,
      default: {
        name: "",
        vehicle_type_code:"",
        parent_id: "",
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      dataForm: {},
    };
  },
  watch: {
    propsData: function (_data) {
      this.dataForm = _data;
    },
  },
};
</script>
